var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApplicationsClient, GetApplicationListPaginatedQuery, PaginatedEnumerableOfApplicationModel, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import RouteNames from "@/app/router/routes";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { Component, Vue, Watch } from "vue-facing-decorator";
const applicationsClient = new ApplicationsClient(window.apiUrl);
let ApplicationsVue = class ApplicationsVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.showInfoMessage = true;
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "ApplicationName",
            direction: SortDirection.Ascending
        }));
        this.query = new GetApplicationListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfApplicationModel();
    }
    created() {
        this.search();
    }
    ;
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        applicationsClient
            .search(this.query)
            .then((response) => {
            this.data = new PaginatedEnumerableOfApplicationModel();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        this.search();
    }
    ;
    edit(application) {
        this.$router.push({ name: RouteNames.Application, params: { id: application.applicationId.toString() } });
    }
    ;
    archive(application) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this application?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            applicationsClient
                .delete(application.applicationId)
                .then(() => {
                application.whenDeleted = new Date();
                Notifier.onOk(`Application # ${application.applicationId} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(application) {
        if (this.working)
            return;
        this.working = true;
        applicationsClient
            .restore(application.applicationId)
            .then(() => {
            application.whenDeleted = undefined;
            Notifier.onOk(`Application # ${application.applicationId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    whenLastActiveString(application) {
        if (!application.whenLastActive)
            return "N/A";
        return DateHelper.convertToFriendlyMomentTimeString(application.whenLastActive || null);
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
};
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    Watch("query.showUnhealthyOnly"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ApplicationsVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ApplicationsVue.prototype, "onSortChanged", null);
ApplicationsVue = __decorate([
    Component({
        name: "ApplicationsVue"
    })
], ApplicationsVue);
export default ApplicationsVue;
